import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const SearchReportStyleWrapper = styled.div`
  .result-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 6px 16px;
    ${responsive.MOBILE`
      padding: 6px 8px;
    `}
    .MuiButtonBase-root {
      column-gap: 4px;
    }

    .header-text {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }

    .header-count {
      color: ${COLORS.cirrus_white};
      background-color: ${COLORS.cirrus_black7};
      padding: 2px 9px 4px 9px;
      border-radius: 8px;
      margin-left: 8px;
      height: 28px;
    }
  }
  .selectReportContainer {
    background-color: ${COLORS.cirrus_white};
    margin-top: 24px;

    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }
  .selectReportFieldContainer {
    padding: 24px 16px 48px 16px;

    ${responsive.MOBILE`
      padding: 16px 8px 16px 8px;
    `}
  }
  .view-reports-button-container {
    margin-top: 30px;

    ${responsive.MOBILE`
      margin-top: 16px;
    `}

    button {
      ${responsive.MOBILE`
        width: 100%;        
      `}
    }
  }

  .result-container {
    margin-top: 32px;
  }
  .selectReportButtonContainer {
    padding-bottom: 20px;
    padding-right: 16px;
    ${responsive.MOBILE`
      justify-content: center;
      padding-bottom: 16px;
      padding-right: 8px;

      button {
         width: 100%;
         max-width: none;
    }
    `}
  }

  .coach-name-label {
    max-width: 250px;
  }
`;

export const ReportChangeModalWrapper = styled.div`
  padding: 24px 16px;

  ${responsive.MOBILE`
    padding: 0 8px 16px 8px;
  `}
`;

export const PendingBillingSearchFormWrapper = styled.div`
  .form-header {
    justify-content: flex-end;
    display: flex;
    align-items: center;
    width: 100%;
    .form-header-left {
      margin-left: 16px;
    }
    .form-header-right {
      margin-right: 16px;
      margin-top: 16px;
      .MuiButtonBase-root {
        height: auto;
        column-gap: 4px;
      }
    }
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100% !important;
  }
`;
